// @ts-strict-ignore
import { Arrange, Button, Box, Spacer, Typography, HTML } from "@aviary";
import { InformationCarousel } from "@aviary/components/InformationCarousel";
import { NewCarousel } from "@aviary/components/NewCarousel";
import { useWordpressHomeSlidesQuery } from "@emerson/data/queries/WordpressHomeSlidesQuery/WordpressHomeSlidesQuery.query";
import type { WordpressHomeSlidesType } from "@emerson/data/queries/WordpressHomeSlidesQuery/WordpressHomeSlidesQuery.query";
import { MockHomeCarouselData } from "@emerson/scenes/HomePage/HomeCarousel/MockHomeCarouselData";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { isE2E } from "@shared/utils/fullscriptEnv/fullscriptEnv";

import * as styles from "./HomeCarousel.styles";

const HomeCarousel = () => {
  const { tablet } = useBreakpoints();
  const isDesktop = tablet.greaterThan;

  const { loading, error, data } = useWordpressHomeSlidesQuery({ skip: isE2E() });

  let homeSlides: WordpressHomeSlidesType[] = MockHomeCarouselData;
  if (!loading && !error && data) {
    homeSlides = data?.homeSlides?.nodes;
  }

  const renderCarousel = () => (
    <InformationCarousel>
      {homeSlides.map((slide, index) => (
        <NewCarousel.Item key={`slide-${index}`}>
          <Box
            style={
              {
                "--slide-image": `url(${slide.homeSlideImage})`,
              } as React.CSSProperties
            }
            css={styles.Carousel.slide}
          >
            <Arrange
              justify="center"
              alignment="center"
              isFullHeight
              isFullWidth
              isVertical={tablet.lessThan}
              isWrapped={false}
              spacing={isDesktop ? "medium" : "none"}
            >
              <div css={styles.Carousel.slideImage} />
              <div css={styles.Carousel.slideContent}>
                <Typography type={isDesktop ? "h1" : "h5"}>{slide.title}</Typography>
                {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
                <HTML dangerouslySetInnerHTML={{ __html: slide.homeSlideText }} />
                <Spacer height={isDesktop ? "oneHalf" : "one"} />
                <Button to={slide.homeSlideActionUrl}>{slide.homeSlideActionText}</Button>
              </div>
            </Arrange>
          </Box>
        </NewCarousel.Item>
      ))}
    </InformationCarousel>
  );

  return <>{renderCarousel()}</>;
};

export { HomeCarousel };
